export default __webpack_public_path__ + "static/media/love.cecf64bf.svg";